import api from '../../../tools/api-tools'
import resUrl from './resource-url'
import qs from 'qs'
// import './index.mock'
class RechargePhone {
  loadData () {
    return api.post(resUrl.index).then(res => {
      let data = res.data
      for (let key of ['rechargePhone', 'rechargePhoneData', 'rechargeQQ']) {
        for (let item of data[key]) {
          item['id'] = item['BusId']
          item['title'] = item['Title']
          item['commend'] = item['Recommend']
          item['desc'] = item['DiscountPrice'] === item['OriginalPrice'] ? '' : `实付${item['DiscountPrice']}元`
          item['isDisable'] = true
          item['isVisable'] = true
        }
      }
      return data
    }).catch(e => {
    })
  }

  checkPhone (phoneNum) {
    return Promise.all([
      api.post(resUrl.checkPhone, qs.stringify({phoneNum})),
      api.post(resUrl.checkPhoneData, qs.stringify({phoneNum}))
    ]).then(values => {
      let chechPhone = values[0].data
      let chechPhoneData = values[1].data
      if (typeof chechPhoneData === 'string') chechPhoneData = []
      return {
        canCharge: typeof chechPhone !== 'string' && 'error_code' in chechPhone && chechPhone.error_code === 0,
        reason: chechPhone.reason || '',
        rechargeDataArr: chechPhoneData
      }
    })
  }
}

export default RechargePhone



// WEBPACK FOOTER //
// ./src/model/rechage/phone/index.js